import { ArticleParagraph2, Image, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { CroppedPhone } from './CroppedPhone';
import * as styles from './styles.css';

export interface ICallContact {
  displayName?: string | null;
  avatar?: string | null;
  description?: string | null;
}

interface IContactsPopupTooltipProps {
  isPhoneVisible: boolean;
  contact: ICallContact;
  phone: string;
  onPhoneClick(): void;
}

export const ContactsPopup: React.FC<IContactsPopupTooltipProps> = ({
  contact,
  phone,
  isPhoneVisible,
  onPhoneClick,
}) => {
  return (
    <div className={styles['container']} data-testid="ContactsPopup">
      <div className={styles['contact']}>
        {contact.avatar && (
          <div className={styles['contact-logo']}>
            <Image src={contact.avatar} />
          </div>
        )}
        <div className={styles['contact-content']}>
          <UIText2>{contact.displayName}</UIText2>
          <div className={styles['contact-description']}>
            {contact.description && <ArticleParagraph2>{contact.description}</ArticleParagraph2>}
          </div>
          <CroppedPhone phone={phone} isCropped={!isPhoneVisible} onClick={onPhoneClick} />
        </div>
      </div>
    </div>
  );
};
